import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import '../assets/css/CustomModal.css';

function CustomModal({ modalIsOpen, closeModal, children }) {
    return (
        <div
            className={`custom-modal  ${modalIsOpen ? '' : 'none !important'}`}
            style={{
                display: modalIsOpen ? '' : 'none !important',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 22222222,
            }}
        >
            <div className="modal-content header-model-content" >
                <button
                    onClick={closeModal}
                    style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer',  border: 'none' }}
                    aria-label="Close Modal"
                >
                    <RxCross2 />
                </button>
                {children}
            </div>
        </div>
    );
}

export default CustomModal;
